/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Input,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Card,
  CardBody,
  Collapse,
} from 'reactstrap';
import { faChevronCircleRight, faSyncAlt } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { loadRecords } from '../../actions/records';
import DatePicker from './DatePicker';

class TableFilter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.setColumnFilterRef = this.setColumnFilterRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.state = {
      columnFilterOpen: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(e) {
    const { columnFilterOpen } = this.state;

    if (this.columnFilterRef && !this.columnFilterRef.contains(e.target)) {
      if (columnFilterOpen) {
        this.setState({ columnFilterOpen: false });
      }
    }
  }

  setColumnFilterRef(node) {
    this.columnFilterRef = node;
  }

  handleSearchTermChange = ({ target }) => {
    const { setSearchTerm } = this.props;
    setSearchTerm(target.name, target.value);
  };

  handleSubmit = (event) => {
    const {
      clearRecords,
      handleToggle,
      setRecordsLoading,
    } = this.props;
    setRecordsLoading(true);
    clearRecords();
    handleToggle(); // close filter dropdown
    event.preventDefault();
    loadRecords()
      .then(() => {
        setRecordsLoading(false);
      }).catch(() => {
        setRecordsLoading(false);
      });
  };

  handleSearchClear = async () => {
    const {
      clearRecords,
      clearSearchTerm,
      handleToggle,
      setRecordsLoading,
    } = this.props;
    setRecordsLoading(true);
    clearRecords();
    handleToggle();
    await clearSearchTerm();
    loadRecords()
      .then(() => {
        setRecordsLoading(false);
      }).catch(() => {
        setRecordsLoading(false);
      });
  };

  render() {
    const { columnFilterOpen } = this.state;
    const {
      agentsLoading,
      setColumnFilterValue,
      handleToggle,
      callFilterOpen,
      columnFilters,
      stEnrollmentId,
      stEnrollmentStatus,
      stClientLastName,
      stClientFirstName,
      stClientPhone,
      stLeadId,
      stAgentFirstName,
      stAgentLastName,
      stAgentNPN,
      stPlanType,
      stPlanCarrier,
      stAgentSentiment,
      stCallerSentiment,
      stAgency,
      agencies,
      showAgencies,
      isAdmin,
    } = this.props;

    return (
      <Form onSubmit={this.handleSubmit} className="px-4 py-2 record-filters">
        <Row>
          <Col>
            <div className="p-2 d-flex">
              <Button color="link" onClick={() => { handleToggle(); }}>
                <FontAwesomeIcon
                  fixedWidth
                  icon={faChevronCircleRight}
                  rotation={callFilterOpen ? 90 : null}
                  size="lg"
                  className="me-1"
                  style={{ transition: 'all .3s ease' }}
                />
                Filter Calls
              </Button>
              <Button
                className="ms-2"
                color="white"
                onClick={this.handleSearchClear}
                style={{
                  transition: 'all .3s ease-in-out',
                  opacity: callFilterOpen ? '1' : '0',
                }}
              >
                Clear Filters
              </Button>
              <Button
                type="submit"
                className="text-white ms-2"
                color="primary"
                style={{
                  transition: 'all .3s ease-in-out',
                  opacity: callFilterOpen ? '1' : '0',
                }}
              >
                Search
              </Button>
              <Button color="white" className="ms-auto">
                <FontAwesomeIcon
                  fixedWidth
                  icon={faSyncAlt}
                  spin={agentsLoading}
                  size="lg"
                  onClick={loadRecords}
                />
              </Button>
            </div>
          </Col>
        </Row>
        <Collapse
          isOpen={callFilterOpen}
          style={{
            transition: 'all .3s ease-in-out',
            opacity: callFilterOpen ? '1' : '0',
          }}
        >
          <Row>
            <Col className="pe-0">
              <Card className="border-0">
                <CardBody>
                  <FormGroup>
                    <Label for="stEnrollmentDateRange">Enrollment Date Range</Label>
                    <DatePicker
                      id="stEnrollmentDateRange"
                      startProp="stEnrollmentStartDate"
                      endProp="stEnrollmentEndDate"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="stEnrollmentId">Enrollment ID</Label>
                    <Input
                      type="text"
                      name="stEnrollmentId"
                      id="stEnrollmentId"
                      value={stEnrollmentId}
                      onChange={this.handleSearchTermChange}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="stEnrollmentStatus">Enrollment Status</Label>
                    <Input
                      type="select"
                      name="stEnrollmentStatus"
                      id="stEnrollmentStatus"
                      value={stEnrollmentStatus}
                      onChange={this.handleSearchTermChange}
                    >
                      <option value="any">Any</option>
                      <option value="yes">Enrolled</option>
                      <option value="no">Not Enrolled</option>
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label for="stPlanType">Plan Type</Label>
                    <Input
                      type="text"
                      name="stPlanType"
                      id="stPlanType"
                      value={stPlanType}
                      onChange={this.handleSearchTermChange}
                    />
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
            <Col className="px-0">
              <Card className="border-0">
                <CardBody>
                  <FormGroup>
                    <Label for="stCallDateRange">Call Date Range</Label>
                    <DatePicker
                      id="stCallDateRange"
                      startProp="stCallStartDate"
                      endProp="stCallEndDate"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="stAgentSentiment">Agent Sentiment</Label>
                    <Input
                      type="select"
                      name="stAgentSentiment"
                      id="stAgentSentiment"
                      value={stAgentSentiment}
                      onChange={this.handleSearchTermChange}
                    >
                      <option value="any">Any</option>
                      <option value="positive">Positive</option>
                      <option value="neutral">Neutral</option>
                      <option value="negative">Negative</option>
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label for="stCallerSentiment">Caller Sentiment</Label>
                    <Input
                      type="select"
                      name="stCallerSentiment"
                      id="stCallerSentiment"
                      value={stCallerSentiment}
                      onChange={this.handleSearchTermChange}
                    >
                      <option value="any">Any</option>
                      <option value="positive">Positive</option>
                      <option value="neutral">Neutral</option>
                      <option value="negative">Negative</option>
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label for="stPlanType">Plan Carrier</Label>
                    <Input
                      type="text"
                      name="stPlanCarrier"
                      id="stPlanCarrier"
                      value={stPlanCarrier}
                      onChange={this.handleSearchTermChange}
                    />
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
            <Col className="px-0">
              <Card className="border-0">
                <CardBody>
                  <FormGroup>
                    <Label for="stAgentFirstName">Agent First Name</Label>
                    <Input
                      type="text"
                      name="stAgentFirstName"
                      id="stAgentFirstName"
                      value={stAgentFirstName}
                      onChange={this.handleSearchTermChange}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="stAgentLastName">Agent Last Name</Label>
                    <Input
                      type="text"
                      name="stAgentLastName"
                      id="stAgentLastName"
                      value={stAgentLastName}
                      onChange={this.handleSearchTermChange}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="stAgentNPN">Agent Broker #</Label>
                    <Input
                      type="text"
                      name="stAgentNPN"
                      id="stAgentNPN"
                      value={stAgentNPN}
                      onChange={this.handleSearchTermChange}
                    />
                  </FormGroup>
                  {showAgencies && isAdmin && (
                    <FormGroup>
                      <Label for="stAgency">Agent Group</Label>
                      <Input
                        type="select"
                        name="stAgency"
                        id="stAgency"
                        value={stAgency}
                        onChange={this.handleSearchTermChange}
                      >
                        <option value="any">Any</option>
                        {agencies.map((agency) => (
                          <option value={agency.id} key={agency.id}>{agency.name}</option>
                        ))}
                      </Input>
                    </FormGroup>
                  )}
                </CardBody>
              </Card>
            </Col>
            <Col className="ps-0">
              <Card className="border-0">
                <CardBody>
                  <FormGroup>
                    <Label for="stLeadId">Lead ID</Label>
                    <Input
                      type="text"
                      name="stLeadId"
                      id="stLeadId"
                      value={stLeadId}
                      onChange={this.handleSearchTermChange}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="stClientLastName">Client Last Name</Label>
                    <Input
                      type="text"
                      name="stClientLastName"
                      id="stClientLastName"
                      value={stClientLastName}
                      onChange={this.handleSearchTermChange}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="stClientFirstName">Client First Name</Label>
                    <Input
                      type="text"
                      name="stClientFirstName"
                      id="stClientFirstName"
                      value={stClientFirstName}
                      onChange={this.handleSearchTermChange}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="stClientPhone">Contact Number</Label>
                    <Input
                      type="text"
                      name="stClientPhone"
                      id="stClientPhone"
                      value={stClientPhone}
                      onChange={this.handleSearchTermChange}
                    />
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Collapse>
        <div className="row">
          <form className="col">
            <div
              className={`d-flex flex-column p-2 ${columnFilterOpen && 'open'}`}
              ref={this.setColumnFilterRef}
              style={{ width: '25%', whiteSpace: 'nowrap' }}
            >
              <button
                className="btn btn-link ms-0 me-auto"
                type="button"
                tabIndex={0}
                id="columnFilterButton"
                onClick={(e) => {
                  // Handling clicking various checkboxes inside of the tooltip
                  if (this.columnFilterRef && (!this.columnFilterRef.contains(e.target)
                                            || this.columnFilterRef === e.target
                                            || e.target.id === 'columnFilterButton'
                  )) {
                    this.setState({ columnFilterOpen: !columnFilterOpen });
                  }
                }}
              >
                <FontAwesomeIcon
                  fixedWidth
                  icon={faChevronCircleRight}
                  rotation={columnFilterOpen ? 90 : null}
                  size="lg"
                  className="me-1"
                  style={{ transition: 'all .3s ease' }}
                />
                Filter Columns
              </button>
              <div
                className="record-dropdown"
                style={{
                  display: columnFilterOpen ? 'flex' : 'none',
                }}
              >
                {columnFilters && columnFilters.map((cf) => {
                  const { id, label, value } = cf;
                  return (
                    <span
                      className={`d-flex align-items-center ${id.indexOf('-') !== -1 ? 'ms-3' : ''}`}
                      key={id}
                    >
                      <input
                        className="form-control-input me-3"
                        onChange={() => { setColumnFilterValue(id, !value); }}
                        id={`planlist-carrier-filter-${id}`}
                        type="checkbox"
                        checked={value}
                        style={{ transform: 'scale(1.25)' }}
                      />
                      <label
                        className="form-control-label"
                        htmlFor={`planlist-carrier-filter-${id}`}
                        id={`planlist-carrier-filter-label-${id}`}
                        style={{ cursor: 'pointer' }}
                      >
                        {label}
                      </label>
                    </span>
                  );
                })}
              </div>
            </div>
          </form>
        </div>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  agentsLoading: state.records.loading,
  agencies: state.agencies.records,
  agents: state.records.agentPage,
  columnFilters: state.records.columnFilters,
  callFilterOpen: state.records.callFilterOpen,
  sort: state.records.sortBy,
  desc: state.records.desc,
  stEnrollmentId: state.records.stEnrollmentId,
  stEnrollmentStatus: state.records.stEnrollmentStatus,
  stClientLastName: state.records.stClientLastName,
  stClientFirstName: state.records.stClientFirstName,
  stClientPhone: state.records.stClientPhone,
  stLeadId: state.records.stLeadId,
  stAgentFirstName: state.records.stAgentFirstName,
  stAgentLastName: state.records.stAgentLastName,
  stAgentNPN: state.records.stAgentNPN,
  stPlanType: state.records.stPlanType,
  srPlanCarrier: state.records.stPlanCarrier,
  stAgentSentiment: state.records.stAgentSentiment,
  stCallerSentiment: state.records.stCallerSentiment,
  stAgency: state.records.stAgency,
  showAgencies: state.theme.features.agencies,
  isAdmin: state.user.is_admin,
});

const mapDispatchToProps = {
  setRecordsLoading: (value) => (dispatch) => dispatch({ type: 'SET_RECORDS_LOADING', payload: value }),
  clearRecords: () => (dispatch) => dispatch({ type: 'CLEAR_RECORD_BOOK' }),
  handleToggle: () => (dispatch) => dispatch({ type: 'TOGGLE_CALL_FILTER' }),
  setSearchTerm: (name, value) => ({ type: 'SET_SEARCH_TERM', name, value }),
  clearSearchTerm: () => (dispatch) => dispatch({ type: 'CLEAR_SEARCH_TERM' }),
  setColumnFilterValue: (id, value) => ({ type: 'SET_COLUMN_FILTER_VALUE', payload: { id, value } }),
};

export default connect(mapStateToProps, mapDispatchToProps)(TableFilter);
